import script from "./PrePurchaseComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PrePurchaseComponent.vue?vue&type=script&setup=true&lang=js"

import "./PrePurchaseComponent.vue?vue&type=style&index=0&id=0586708e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0586708e"]])

export default __exports__